import { createContext, useContext } from "react";
export var UserPreferencesContext = createContext({});
if (process.env.NODE_ENV !== "production") {
    UserPreferencesContext.displayName = "UserPreferencesContext";
}
export var useUserPreferences = function () { return useContext(UserPreferencesContext); };
//# sourceMappingURL=use-user-preferences.js.map